"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _configuration = require("./configuration");
var screens = (0, _configuration.getConf)('screens', {});

// IMPORTANT
// FIXME: after babel update (to 7) use conditional compilation to skip import (reduce bundle size)
// use the package babel-plugin-conditional-compile or babel-plugin-conditional-compilation

// import base Screens if not replaced in custom project
// note: require should be used here to avoid importing the screen when it's not used

if (!screens.ItemOverview) {
  var _require = require("./Screens/ItemOverview"),
    ItemOverview = _require.ItemOverview;
  screens.ItemOverview = ItemOverview;
}
if (!screens.Configurator) {
  var _require2 = require("./Screens/Configurator/Screen"),
    ConnectedConfiguratorScreen = _require2.ConnectedConfiguratorScreen;
  screens.Configurator = ConnectedConfiguratorScreen;
}
if (!screens.CalculationWidget) {
  var _require3 = require("./Screens/Configurator/CalculationWidgetScreen"),
    ConnectedCalculationWidgetScreen = _require3.ConnectedCalculationWidgetScreen;
  screens.CalculationWidget = ConnectedCalculationWidgetScreen;
}
if (!screens.DesignerProductPreview) {
  var _require4 = require("./Screens/DesignerProductPreview/Screen"),
    ConnectedDesignerProductPreviewScreen = _require4.ConnectedDesignerProductPreviewScreen;
  screens.DesignerProductPreview = ConnectedDesignerProductPreviewScreen;
}
if (!screens.Configurator) {
  throw new Error('The Configurator Screen component must be specified in the application configuration!');
}
var _default = exports["default"] = screens;